// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Game_wrapper__1os_n","background":"Game_background__2aisz","resetButton":"Game_resetButton__3MLIz"};